import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-consignment-carrier-one',
  templateUrl: './consignment-carrier-one.component.html',
  styleUrls: ['./consignment-carrier-one.component.css']
})
export class ConsignmentCarrierOneComponent implements OnInit {
    consignmentKeyno;

    public setting?: Setting;

    public grid?: GridOptions;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.consignmentKeyno = this.stateService.getStateParams()['consignment_keyno'];
    }

    private async loadSetting() {
        if (!!this.consignmentKeyno) {
            this.setting = (await this.datatask.Post(2669, { consignment_keyno: this.consignmentKeyno }))[0];
        }
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_consignmentcollidetail_carriers_grid')
                .setLoadDataFunction({
                    method: 2668,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async saveChanges() {
        if (!!this.setting) {
            try {
                this.saving = true;

                const selectedItems = (this.grid?.gridfunc?.getAllRows() ?? []).map((row) => ({
                    carrier_keyno: row['carrier_keyno'],
                    quantity: row['quantity'],
                    consignmentcarrier_keyno: row['consignmentcarrier_keyno']
                }));

                const mergeObj = {
                	...this.setting,
                	records: selectedItems
                }

                const response = (await this.datatask.Post(2670, mergeObj))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    consignment_keyno: string;
    consignmentcolli_keyno: string;
}
